import React, { useEffect, useState } from "react"

import {
  Form,
  CheckboxInput,
} from "./UI/Form"

import 'react-credit-cards/lib/styles'

import CreditCardPaymentForm from "./UI/CreditCardPaymentForm";
import { validateCreditCardDetails } from './utils/creditcard'

export default props => {
  const [paymentFormVisible, setPaymentFormVisible] = useState(false)
  const [submittingOrder, setSubmittingOrder] = useState(false)
  const [validCreditCard, setValidCreditCard] = useState(false)
  const [displayValidationErrors, setDisplayValidationErrors] = useState(false)
  const [order, setOrder] = useState(props.order);
  const [creditCardNumber, setCreditCardNumber] = useState("")

  useEffect(() => {
    $(document).on("keydown", ":input:not(textarea)", function (event) {
      return event.key != "Enter";
    })
  }, [])

  const saveCreditCardPrefix = async (creditCardNumber) => {
    const cleanedNumber = creditCardNumber.replace(/[\s-]/g, '');
    let paymentMethod = "OT"

    if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(cleanedNumber)) {
      // Visa (VI)
      paymentMethod = "VI";
    } else if (/^5[1-5][0-9]{14}$/.test(cleanedNumber) || /^2(2[2-9][1-9]|[3-6][0-9]{2}|7[0-1][0-9]|720)[0-9]{12}$/.test(cleanedNumber)) {
      // MasterCard (MC)
      paymentMethod = "MC";
    } else if (/^3[47][0-9]{13}$/.test(cleanedNumber)) {
      // American Express (AE)
      paymentMethod = "AE";
    } else {
      // Other (OT)
      paymentMethod = "OT"
    }
    await fetch(`/orders/${props.order.id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content"),
      },
      body: JSON.stringify({order: {payment_method: paymentMethod}})
    });
    return paymentMethod;
  };

  const updateOrder = () => {
    let body = new FormData(document.getElementById(props.orderFormId))

    return fetch(props.orderPath, {
      body: body,
      method: "PATCH",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").getAttribute("content"),
      },
    })
    .then(response => response.json())
    .then(response => {
      if (response.order) {
        setOrder(response.order)
      } else {
        handleUnexpectedError("Unexpected error occurred while updating the order");
      }
      return response;
    });
  }
  const submitOrder = async e => {
    e.preventDefault()
    setDisplayValidationErrors(true)
    setSubmittingOrder(true)
    await saveCreditCardPrefix(creditCardNumber)

    updateOrder().then(response => {
      if (!validCreditCard) {
        setSubmittingOrder(false);
        return;
      }

      if (Object.keys(response).length > 0 && Object.keys(response.order.errors).length > 0) {
        setSubmittingOrder(false);
        return;
      }
      document.getElementById('payment-form').submit();
    })
  }

  const submitOrderWithoutPayment = e => {
    e.preventDefault()
    setDisplayValidationErrors(true)

    document.getElementById(props.orderFormId).submit();
  }

  return (
    <div className="edit_order">
      <Form className="simple-form" id="order-form">
        {props.children}
      </Form>

      <CheckboxInput
        label="Pay by credit card now"
        name="payment_type"
        wrapperHTMLClassName="order_payment_type"
        onChange={(e) => setPaymentFormVisible(e.target.checked)}
      />

      {paymentFormVisible &&
        <CreditCardPaymentForm
          paymentGatewayData={order.paymentGatewayData}
          handleValidationChange={(valid) => setValidCreditCard(valid)}
          displayValidationErrors={displayValidationErrors}
          resultUrl={props.orderUrl}
          number={creditCardNumber}
          setNumber={setCreditCardNumber}
        />
      }
      {paymentFormVisible && (
        <div className="form-actions">
          <button
            className="btn btn-primary btn-lg text-uppercase"
            name="commit"
            onClick={submitOrder}
            disabled={submittingOrder}
          >
            {submittingOrder ? 'Processing...' : 'Submit payment'}
          </button>
        </div>
      )}

      {!paymentFormVisible && (
        <div className="form-actions">
          <button
            className="btn btn-primary btn-lg text-uppercase"
            name="commit"
            onClick={submitOrderWithoutPayment}
          >
            Update Order
          </button>
        </div>
      )}
    </div>
  )
}
